import Main from '@/modules/main/Main.vue';
import Header from '@/modules/header/Header.vue';
import Dashboard from '@/modules/dashboard/Dashboard.vue';
import MinhaConta from '@/modules/minha-conta/MinhaConta.vue';
import MinhaEmpresa from '@/modules/minha-empresa/MinhaEmpresa.vue';
import Cotacoes from '@/modules/cotacao/listagem/ListagemCotacao.vue';
import CadastroCotacao from '@/modules/cotacao/cadastro/CadastroCotacao.vue';
import CotacaoRespostas from '@/modules/cotacao/resposta/CotacaoRespostas.vue';
import RespostaDetalhes from '@/modules/cotacao/resposta/detalhes/RespostaDetalhes.vue';
import Carrinho from '@/modules/carrinho/listagem/Carrinho.vue';
import Finalizacao from '@/modules/carrinho/finalizacao/Finalizacao.vue';
import Compras from '@/modules/compra/listagem/ListagemCompra.vue';
import CompraDetalhes from '@/modules/compra/detalhes/CompraDetalhes.vue';
import CadastroCompra from '@/modules/compra/cadastro/CadastroCompra.vue';
import IndicadoresFornecedor from '@/modules/indicadores-fornecedor/IndicadoresFornecedor.vue';
import Produtos from '@/modules/produtos/Produtos.vue';
import CadastroProduto from '@/modules/produtos/tabs/CadastroProdutoTabs.vue';
import MatrizResposta from '@/modules/cotacao/resposta/matriz/MatrizResposta.vue';
import MeuPainel from '@/modules/meu-painel/MeuPainel.vue';
import UnidadesMedida from '@/modules/unidade-medida/UnidadesMedida.vue';
import CadastroUnidadeMedida from '@/modules/unidade-medida/CadastroUnidadeMedida.vue';
import Grupos from '@/modules/grupos-produto/Grupo.vue';
import CadastroGrupos from '@/modules/grupos-produto/CadastroGrupo.vue';
import TipoNotaEntrada from '@/modules/tipo-nota-entrada/TipoNotaEntrada.vue';
import CadastroTipoNotaEntrada from '@/modules/tipo-nota-entrada/CadastroTipoNotaEntrada.vue';
import Projeto from '@/modules/projeto/Projeto.vue';
import CadastroProjeto from '@/modules/projeto/CadastroProjeto.vue';
import CentroCusto from '@/modules/centro-custo/CentroCusto.vue';
import CadastroCentroCusto from '@/modules/centro-custo/CadastroCentroCusto.vue';
import EdicaoCotacao from '@/modules/cotacao/edicao/EdicaoCotacao.vue';
import store from '@/store';

import { INITIALIZE_FROM_COOKIES_AC } from '@/store/auth/actions.type';

import ImportarCotacao from '@/modules/cotacao/importacao/ImportarCotacao.vue';
import CadastroRequisicao from '@/modules/requisicao/cadastro/CadastroRequisicao.vue';
import ListagemRequisicao from '@/modules/requisicao/listagem/ListagemRequisicao.vue';
import RequisicaoDetalhes from '@/modules/requisicao/detalhes/RequisicaoDetalhes.vue';
import RequisicaoCotacao from '@/modules/cotacao/requisicao/RequisicaoCotacao.vue';
import ConfiguracaoAprovacao from '@/modules/configuracao-aprovacao/ConfiguracaoAprovacao.vue';
import CadastroConfiguracaoAprovacao
  from '@/modules/configuracao-aprovacao/cadastro/CadastroConfiguracaoAprovacao.vue';
import ListagemAprovacoes from '@/modules/aprovacao/listagem/ListagemAprovacoes.vue';
import AprovacaoDetalhes from '@/modules/aprovacao/detalhes/AprovacaoDetalhes.vue';
import RequisicaoCompra from '@/modules/compra/requisicao/RequisicaoCompra.vue';
import RequisicaoGeracao from '@/modules/requisicao/geracao/RequisicaoGeracao.vue';
import ModosDePagamento from '@/modules/modos-pagamento/ModosDePagamento.vue';
import CadastroModosDePagamento from '@/modules/modos-pagamento/CadastroModosDePagamento.vue';
import GestaoEntregas from '@/modules/entregas/GestaoEntregas.vue';
import IndicadoresCompras from '@/modules/indicadores-compras/IndicadoresCompras.vue';
import PainelIntegracao from '@/modules/painel-integracao/PainelIntegracao.vue';
import MensagemPersonalizada from '@/modules/mensagens-personalizadas/MensagemPersonalizada.vue';
import CadastroMensagemPersonalizada
  from '@/modules/mensagens-personalizadas/cadastro/CadastroMensagemPersonalizada.vue';
import ConfiguracaoMoedas from '@/modules/configuracoes-moedas/ConfiguracaoMoedas.vue';
import TabelaPrecoListagem from '@/modules/tabela-preco/TabelaPrecoListagem.vue';
import TabelaPrecoCadastro from '@/modules/tabela-preco/cadastro/TabelaPrecoCadastro.vue';
import AprovacaoSolicitacao from '@/modules/aprovacao-solicitacao/AprovacaoSolicitacao.vue';
import AlcadasCompra from '@/modules/alcadas/AlcadasCompra.vue';
import AlcadasSolicitacao from '@/modules/alcadas/AlcadasSolicitacao.vue';
import grupoCompra from './grupo-compra-router';
import gestaoFornecedores from './gestao-fornecedores';
import paginaFornecedor from './pagina-fornecedor';
import gestaoFrete from './gestao-frete';

const beforeEnterAuth = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    if (store.getters.tokenFromStorage) {
      store.dispatch(INITIALIZE_FROM_COOKIES_AC);
      return next();
    }
    return next('/login');
  }
  return next();
};

export default {
  path: '/',
  name: 'main',
  redirect: { name: 'main.meu-painel' },
  components: {
    default: Main,
    header: Header,
  },
  children: [
    {
      path: 'meu-painel',
      name: 'main.meu-painel',
      components: {
        default: MeuPainel,
      },
    },
    {
      path: 'dashboard',
      name: 'main.dashboard',
      components: {
        default: Dashboard,
      },
    },
    {
      path: 'indicador-fornecedores',
      name: 'main.indicadores-fornecedor',
      components: {
        default: IndicadoresFornecedor,
      },
    },
    {
      path: 'indicadores-compras',
      name: 'main.indicadores-compras',
      components: {
        default: IndicadoresCompras,
      },
    },
    {
      path: 'minha-conta',
      name: 'main.minha-conta',
      components: {
        default: MinhaConta,
      },
    },
    {
      path: 'minha-empresa',
      name: 'main.minha-empresa',
      components: {
        default: MinhaEmpresa,
      },
    },
    {
      path: 'produtos',
      name: 'main.produtos',
      components: {
        default: Produtos,
      },
    },
    {
      path: '/cadastro-produto',
      name: 'main.produto.cadastro',
      components: {
        default: CadastroProduto,
      },
    },
    {
      path: '/cadastro-produto/:id',
      name: 'main.produto.edicao',
      components: {
        default: CadastroProduto,
      },
      props: true,
    },
    {
      path: 'carrinho',
      name: 'main.carrinho',
      components: {
        default: Carrinho,
      },
    },
    {
      path: 'carrinho/finalizacao/:id',
      name: 'main.carrinho.finalizacao',
      components: {
        default: Finalizacao,
      },
    },
    {
      path: 'cotacoes',
      name: 'main.cotacoes',
      components: {
        default: Cotacoes,
      },
    },
    {
      path: 'cadastro-cotacao',
      name: 'main.cotacoes.cadastro',
      components: {
        default: CadastroCotacao,
      },
      props: true,
    },
    {
      path: 'cadastro-cotacao/:id',
      name: 'main.cotacoes.edicao',
      components: {
        default: CadastroCotacao,
      },
      props: true,
    },
    {
      path: 'importar-cotacao',
      name: 'main.cotacoes.importacao',
      components: {
        default: ImportarCotacao,
      },
    },
    {
      path: 'requisicao-cotacao',
      name: 'main.cotacoes.requisicao-cotacao',
      components: {
        default: RequisicaoCotacao,
      },
      props: true,
    },
    {
      path: 'cotacao/:id/respostas',
      name: 'main.cotacoes.respostas',
      components: {
        default: CotacaoRespostas,
      },
    },
    {
      path: 'cotacao/:id/respostas/:idResposta',
      name: 'main.cotacoes.respostas.detalhes',
      components: {
        default: RespostaDetalhes,
      },
    },
    {
      path: 'cotacao/respostas/matriz',
      name: 'main.cotacoes.respostas.matriz',
      components: {
        default: MatrizResposta,
      },
    },
    {
      path: 'cotacao/:id/edicao',
      name: 'main.cotacoes.edicao-parcial',
      components: {
        default: EdicaoCotacao,
      },
      props: true,
    },
    {
      path: 'compras',
      name: 'main.compras',
      components: {
        default: Compras,
      },
    },
    {
      path: '/cadastro-compra',
      name: 'main.compras.cadastro',
      components: {
        default: CadastroCompra,
      },
      props: true,
    },
    {
      path: '/cadastro-compra/:id',
      name: 'main.compras.edicao',
      components: {
        default: CadastroCompra,
      },
      props: true,
    },
    {
      path: 'compra/:id/detalhes',
      name: 'main.compras.detalhes',
      components: {
        default: CompraDetalhes,
      },
    },
    {
      path: 'requisicao-compra',
      name: 'main.compras.requisicao-compra',
      components: {
        default: RequisicaoCompra,
      },
      props: true,
    },
    {
      path: 'requisicoes',
      name: 'main.requisicoes',
      components: {
        default: ListagemRequisicao,
      },
    },
    {
      path: 'cadastro-requisicao',
      name: 'main.requisicoes.cadastro',
      components: {
        default: CadastroRequisicao,
      },
    },
    {
      path: 'cadastro-requisicao/:id',
      name: 'main.requisicoes.edicao',
      components: {
        default: CadastroRequisicao,
      },
      props: true,
    },
    {
      path: 'requisicao/:id',
      name: 'main.requiscao.detalhes',
      components: {
        default: RequisicaoDetalhes,
      },
    },
    {
      path: 'requisicoes/gerar',
      name: 'main.requisicoes.geracao',
      components: {
        default: RequisicaoGeracao,
      },
    },
    {
      path: 'alcadas-compra',
      name: 'main.alcadas-compra',
      components: {
        default: AlcadasCompra,
      },
    },
    {
      path: 'alcadas-solicitacao',
      name: 'main.alcadas-solicitacao',
      components: {
        default: AlcadasSolicitacao,
      },
    },
    {
      path: 'configuracoes-aprovacao',
      name: 'main.configuracoes-aprovacao',
      components: {
        default: ConfiguracaoAprovacao,
      },
    },
    {
      path: 'configuracoes-aprovacao/cadastro',
      name: 'main.configuracoes-aprovacao.cadastro',
      components: {
        default: CadastroConfiguracaoAprovacao,
      },
    },
    {
      path: 'configuracoes-aprovacao/cadastro/:id',
      name: 'main.configuracoes-aprovacao.edicao',
      components: {
        default: CadastroConfiguracaoAprovacao,
      },
    },
    {
      path: 'aprovacoes-solicitacoes',
      name: 'main.aprovacoes-solicitacoes',
      components: {
        default: AprovacaoSolicitacao,
      },
    },
    {
      path: 'aprovacoes',
      name: 'main.aprovacoes',
      components: {
        default: ListagemAprovacoes,
      },
    },
    {
      path: 'aprovacao/:id',
      name: 'main.aprovacao.detalhes',
      components: {
        default: AprovacaoDetalhes,
      },
    },
    {
      path: '/unidades-medidas',
      name: 'main.unidades',
      components: {
        default: UnidadesMedida,
      },
    },
    {
      path: '/cadastro-unidade-medida',
      name: 'main.unidades.cadastro',
      components: {
        default: CadastroUnidadeMedida,
      },
    },
    {
      path: '/cadastro-unidade-medida/:id',
      name: 'main.unidades.edicao',
      components: {
        default: CadastroUnidadeMedida,
      },
      props: true,
    },
    {
      path: '/categorias',
      name: 'main.grupos',
      components: {
        default: Grupos,
      },
    },
    {
      path: '/categoria/cadastro',
      name: 'main.grupos.cadastro',
      components: {
        default: CadastroGrupos,
      },
    },
    {
      path: '/categoria/cadastro/:id',
      name: 'main.grupos.edicao',
      components: {
        default: CadastroGrupos,
      },
      props: true,
    },
    {
      path: '/modos-pagamento',
      name: 'main.modos-pagamento',
      components: {
        default: ModosDePagamento,
      },
    },
    {
      path: '/modos-pagamento/cadastro',
      name: 'main.modos-pagamento.cadastro',
      components: {
        default: CadastroModosDePagamento,
      },
    },
    {
      path: '/modos-pagamento/cadastro/:id',
      name: 'main.modos-pagamento.edicao',
      components: {
        default: CadastroModosDePagamento,
      },
      props: true,
    },
    {
      path: 'configuracoes-nota-entrada',
      name: 'main.configuracoes-notas-entrada',
      components: {
        default: TipoNotaEntrada,
      },
    },
    {
      path: 'configuracoes-nota-entrada/cadastro',
      name: 'main.configuracoes-notas-entrada.cadastro',
      components: {
        default: CadastroTipoNotaEntrada,
      },
    },
    {
      path: 'configuracoes-nota-entrada/cadastro/:id',
      name: 'main.configuracoes-notas-entrada.edicao',
      components: {
        default: CadastroTipoNotaEntrada,
      },
      prosp: true,
    },
    {
      path: '/gesta-entregas',
      name: 'main.gesta-entregas',
      components: {
        default: GestaoEntregas,
      },
    },
    {
      path: '/integracao',
      name: 'main.integracao',
      components: {
        default: PainelIntegracao,
      },
    },
    {
      path: '/projetos',
      name: 'main.projetos',
      components: {
        default: Projeto,
      },
    },
    {
      path: '/projetos/cadastro',
      name: 'main.projetos.cadastro',
      components: {
        default: CadastroProjeto,
      },
    },
    {
      path: '/projetos/:id',
      name: 'main.projetos.edicao',
      components: {
        default: CadastroProjeto,
      },
      props: true,
    },
    {
      path: '/centros-custo',
      name: 'main.centros-custo',
      components: {
        default: CentroCusto,
      },
    },
    {
      path: '/centros-custo/cadastro',
      name: 'main.centros-custo.cadastro',
      components: {
        default: CadastroCentroCusto,
      },
    },
    {
      path: '/centros-custo/:id',
      name: 'main.centros-custo.edicao',
      components: {
        default: CadastroCentroCusto,
      },
      params: true,
    },
    {
      path: '/mensagens',
      name: 'main.messages',
      components: {
        default: MensagemPersonalizada,
      },
    },
    {
      path: '/mensagens/cadastro',
      name: 'main.messages.cadastro',
      components: {
        default: CadastroMensagemPersonalizada,
      },
    },
    {
      path: '/mensagens/edicao:id',
      name: 'main.messages.edicao',
      components: {
        default: CadastroMensagemPersonalizada,
      },
      params: true,
    },
    {
      path: '/configuracoes-moedas',
      name: 'main.configuracoes-moedas',
      components: {
        default: ConfiguracaoMoedas,
      },
    },
    {
      path: '/tabelas-preco',
      name: 'main.tabelas-preco',
      components: {
        default: TabelaPrecoListagem,
      },
    },
    {
      path: '/tabelas-preco/cadastro',
      name: 'main.tabelas-preco.cadastro',
      components: {
        default: TabelaPrecoCadastro,
      },
    },
    {
      path: '/tabelas-preco/:id',
      name: 'main.tabelas-preco.edicao',
      components: {
        default: TabelaPrecoCadastro,
      },
      params: true,
    },
    ...grupoCompra,
    ...gestaoFornecedores,
    ...paginaFornecedor,
    ...gestaoFrete,
  ],
  beforeEnter: beforeEnterAuth,
};
